import { teamFormation, teamFormationsToMap } from '../../../typings/formations';

export type FormationLabels = {
  [key in teamFormationsToMap]: string;
};

export const formationLabels: FormationLabels = {
  '3142': '352',
  '343d': '343',
  '41212': '442',
  '4240': '424',
};
// @ts-ignore
export const getFormationLabel = (formation: teamFormation): string => formationLabels[formation] || formation;
